import { parseFullName } from 'parse-full-name';

export default (name) => {
  const userName = name || '';
  const parsed = parseFullName(userName.replace(/\s\s+/g, ' ').trim());
  if (!parsed.first && parsed.last) {
    parsed.first = parsed.last;
    parsed.last = '';
  }
  return parsed;
};



// WEBPACK FOOTER //
// ./src/modules/parse-name.js